import { LANG } from '@/constants';
import userService from '@/service/user';
import ARMS from '@/common/arms';

export default {
  state: () => ({
    userInfo: null,
    sLocale: LANG.en,
    useBstation: false,
  }),
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setLocale(state, data) {
      state.sLocale = data;
    },
    setUseBstation(state, data) {
      state.useBstation = data;
    }
  },
  actions: {
    async getUserInfo({ commit }) {
      try {
        const { data } = await userService.getUserInfo();
        ARMS.setConfig({
          setUsername: function () {
            return data.mid.toString();
          }
        });
        commit('setUserInfo', data);
      } catch (e) {
        console.log('**error(actions.getUserInfo):', e);
      }
    },
  },
  getter: {

  }
};